module.exports = __webpack_public_path__ + "static/media/vidyard-logo.14d7f48e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logos/vidyard-logo.svg
// module id = DaXa
// module chunks = 89